export const NativeMapListeners = {
  ZoomChanged: 'zoom_changed',
  Dragstart: 'dragstart',
  Dragend: 'dragend',
  BoundsChanged: 'bounds_changed',
  TiltChanged: 'tilt_changed',
  Click: 'click',
};

export const NativeMarkerListeners = {
  Dragend: 'dragend',
  Click: 'click',
};

export const MapEvents = {
  MapDragend: 'mapDragend',
  MapDragstart: 'mapDragstart',
  ZoomChanged: 'zoomChanged',
  TiltChanged: 'tiltChanged',
  CenterChanged: 'centerChanged',
  Mounted: 'mounted',
  DrawingAreaChanged: 'drawingAreaChanged',
  DrawingAreaComplete: 'drawingAreaComplete',
  MapClick: 'mapClick',
};

export const MarkerEvents = {
  MarkerDragend: 'markerDragend',
  MarkerClick: 'markerClick',
};

export const DrawerEvents = {
  OverlayComplete: 'overlaycomplete',
};

export const MapZoomLevel = {
  XXSmall: 10,
  XSmall: 11,
  Small: 13,
  SmallMedium: 15,
  Medium: 17,
  Large: 20,
  XLarge: 23,
};

export const ControlsPosition = {
  TopLeft: 1,
  TopCenter: 2,
  TopRight: 3,
};

export const ElementTypes = {
  Geometry: 'geometry',
  LabelsIcon: 'labels.icon',
  LabelsTextFill: 'labels.text.fill',
  LabelsTextStroke: 'labels.text.stroke',
};

export const FeatureTypes = {
  AdministrativeLandParcel: 'administrative.land_parcel',
  PointOfInterest: 'poi',
  PointOfInterestPark: 'poi.park',
  Road: 'road',
  RoadArterial: 'road.arterial',
  RoadHighway: 'road.highway',
  RoadLocal: 'road.local',
  TransitLine: 'transit.line',
  TransitStation: 'transit.station',
  Water: 'water',
};

export const MapColors = {
  White: '#ffffff',
  Blue: '#b3e5fc',
  DarkBlue: '#009fd4',
  Gray: 'gray',
  GreyGeometryLight: '#dadada',
  GreyGeometry: '#eeeeee',
  GreyGeometryPark: '#DCEDC8',
  GreyGeometryTransitLine: '#e5e5e5',
  GreyLabelsTextStroke: '#f5f5f5',
  GreyLabelsTextFillLight: '#bdbdbd',
  GreyLabelsTextFill: '#9e9e9e',
  GreyLabelsTextFillDark: '#757575',
  GreyLabelsTextFillDarkest: '#616161',
};

export const MapProperty = {
  Width: 'width',
  Height: 'height',
  Zoom: 'zoom',
  Center: 'center',
  MarkersData: 'markersData',
  Bounds: 'bounds',
  DrawingArea: 'drawingArea',
  DrawingOptions: 'drawingOptions',
};

export const MapBoundsProperty = {
  MinLat: 'minLat',
  MinLon: 'minLon',
  MaxLat: 'maxLat',
  MaxLon: 'maxLon',
};

export const MapDrawingMode = {
  Polygon: 'polygon',
};

export const MapPolygonEvent = {
  InsertAt: 'insert_at',
  RemoveAt: 'remove_at',
  SetAt: 'set_at',
  Dragend: 'dragend',
};
